
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import UserShield from '../../../Components/UserShield'
import FederationFlag from '../../../Components/FederationFlag'
import { Firebase, Auth } from '../../../../Core'
import * as utils from '../../../Ranking/ranking.utils'

class Federation extends React.Component {
  constructor(props) {
    super(props)
  }

  renderUserInfo(player) {
    const { user, currentUser, rankingObfuscated } = this.props
    let obfuscated = rankingObfuscated == 'undefined' ? 'normal' : rankingObfuscated
    let name =
      obfuscated == 'obfuscated'
        ? utils.obfuscated(user.name, currentUser)
        : obfuscated == 'alias'
        ? user.name == currentUser.name
          ? user.name
          : user.alias
        : user.name
    return (
      <li key={player.licenseId} className={player.licenseId == user.id ? 'active' : ''}>
        <UserShield shield={player.colonyShield} />
        <div className="settings--member__info">
          <div>{player.colonyName}</div>
          <div>{name}</div>
        </div>
      </li>
    )
  }

  render() {
    const { federationUsers, federation, next } = this.props

    return (
      <div className="container background background--challenge">
        <div className="content">
          <div className="settings">
            <div className="settings--content ">
              <div className="settings--title">
                <FormattedMessage id={'phase.yourFederation'} />
              </div>
              <div className="settings--customization">
                <div className="settings--customization__flag">
                  <FederationFlag flag={federation.flag} />
                  <div className="settings--federation__name">{federation.name}</div>
                </div>
                <div className="settings--federation__members">
                  <div className="title">
                    <FormattedMessage id={'phase.federationUsers'} />
                  </div>
                  <ul className="settings--federation__items">
                    {federationUsers.map((player) => this.renderUserInfo(player))}
                  </ul>
                </div>
              </div>
              <div className="settings--buttons">
                <div onClick={() => next()} className="btn--orange">
                  <span className="icon-rocket"></span>
                  <span>
                    <FormattedMessage id={'phase.begin'} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    federationUsers: Firebase.selectors.getUserFederationPartners(state),
    federation: Firebase.selectors.getUserFederation(state),
    user: Auth.selectors.getUserInfo(state),
    currentUser: Firebase.selectors.getUserData(state),
    rankingObfuscated: Firebase.selectors.getObfuscatedRankingFlag(state),
  }
}
Federation.propTypes = {
  federationUsers: PropTypes.array,
  federation: PropTypes.object,
  user: PropTypes.object,
  next: PropTypes.func,
  currentUser: PropTypes.object,
  rankingObfuscated: PropTypes.string,
}

export default connect(mapStateToProps)(Federation)
